import { render, staticRenderFns } from "./RefundConsignTable.vue?vue&type=template&id=799f4d22&scoped=true"
import script from "./RefundConsignTable.vue?vue&type=script&lang=ts"
export * from "./RefundConsignTable.vue?vue&type=script&lang=ts"
import style0 from "./RefundConsignTable.vue?vue&type=style&index=0&id=799f4d22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f4d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('799f4d22')) {
      api.createRecord('799f4d22', component.options)
    } else {
      api.reload('799f4d22', component.options)
    }
    module.hot.accept("./RefundConsignTable.vue?vue&type=template&id=799f4d22&scoped=true", function () {
      api.rerender('799f4d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refund-consign/RefundConsignTable.vue"
export default component.exports